import type { NeckPosition } from "./guitarEngine";

/**
 * Colores fijos por grado escala (pedagogía).
 * No deben cambiar con el tema UI del módulo (Escalas/Modos/…).
 */
export const PEDAGOGICAL_DEGREE_HEX = [
  "#FF4D4D", // I — tónica (rojo)
  "#F97316", // II
  "#2DD4BF", // III — cian
  "#EAB308", // IV
  "#22C55E", // V — verde
  "#3B82F6", // VI
  "#8B5CF6", // VII
] as const;

/** Alias histórico — misma paleta pedagógica. */
export const SATURATED_DEGREE_HEX = PEDAGOGICAL_DEGREE_HEX;

/** Acento de referencia para UI estática (tónica = mismo rojo pedagógico). */
export const SCALES_MODULE_ACCENT = PEDAGOGICAL_DEGREE_HEX[0];
export const SCALES_MODULE_ACCENT_HOVER = "#E54444";
export const SCALES_MODULE_ACCENT_MUTED_BG = "rgba(255, 77, 77, 0.12)";
export const SCALES_MODULE_ACCENT_BORDER = "rgba(255, 77, 77, 0.28)";

/** Diapasón luthería (misma referencia que Canciones). */
export { LUTHERIE_FRETBOARD_DARK as FRETBOARD_DARK_BG } from "./fretboardLutherieTheme";

const DEGREE_TO_INDEX: Record<string, number> = {
  R: 0,
  "2": 1,
  b2: 1,
  "3": 2,
  b3: 2,
  "4": 3,
  "#4": 3,
  "5": 4,
  b5: 4,
  "6": 5,
  b6: 5,
  "7": 6,
  b7: 6,
};

/** Bordes pastel Serenity para grados en mástil Explore (outline, no relleno pesado). */
export const SERENITY_DEGREE_STROKES = [
  "rgba(248, 113, 113, 0.7)", // I — tónica
  "rgba(196, 181, 253, 0.55)", // II lavanda
  "rgba(167, 243, 208, 0.55)", // III menta
  "rgba(103, 232, 249, 0.5)", // IV cyan
  "rgba(253, 186, 116, 0.5)", // V melocotón
  "rgba(191, 219, 254, 0.5)", // VI azul suave
  "rgba(216, 180, 254, 0.5)", // VII lila
] as const;

export const SERENITY_TONIC_FILL = "#f87171";

export function exploreWireframeDegreeIndex(degree?: string): number {
  if (!degree) return 3;
  return DEGREE_TO_INDEX[degree] ?? 3;
}

export function chipHexForNeckHighlight(
  highlight: NeckPosition["highlight"] | undefined,
  degree?: string
): string {
  const S = PEDAGOGICAL_DEGREE_HEX;
  switch (highlight) {
    case "root":
    case "active":
      return S[0];
    case "third":
      return S[2];
    case "fifth":
      return S[4];
    case "scale": {
      if (degree && DEGREE_TO_INDEX[degree] !== undefined) {
        return S[DEGREE_TO_INDEX[degree] % 7];
      }
      return S[3];
    }
    default:
      return S[3];
  }
}
